/* Respito Digital — interattività statica (countdown + FAQ accordion) */
(function () {
  'use strict';

  /* ---------- FAQ ACCORDION ---------- */
  function initAccordions() {
    var triggers = document.querySelectorAll('button[aria-controls]');
    triggers.forEach(function (btn) {
      var id = btn.getAttribute('aria-controls');
      var panel = document.getElementById(id);
      if (!panel || panel.getAttribute('role') !== 'region') return;
      // collapse by default
      panel.hidden = true;
      btn.setAttribute('data-state', 'closed');
      panel.setAttribute('data-state', 'closed');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = panel.hidden;
        // close siblings within same accordion root (type=single behaviour)
        var root = btn.closest('[data-orientation]') ? btn.closest('[class*="space-y"]') || document : document;
        if (open && root) {
          root.querySelectorAll('button[aria-controls]').forEach(function (other) {
            if (other === btn) return;
            var op = document.getElementById(other.getAttribute('aria-controls'));
            if (op && op.getAttribute('role') === 'region') {
              op.hidden = true;
              op.setAttribute('data-state', 'closed');
              other.setAttribute('data-state', 'closed');
              other.setAttribute('aria-expanded', 'false');
            }
          });
        }
        panel.hidden = !open;
        var st = open ? 'open' : 'closed';
        panel.setAttribute('data-state', st);
        btn.setAttribute('data-state', st);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- COUNTDOWN ---------- */
  function initCountdowns() {
    var UNITS = { d: 86400, h: 3600, m: 60, s: 1 };
    var groups = [];
    // a value span = numeric text whose next sibling span is a unit label
    document.querySelectorAll('span').forEach(function (span) {
      var t = (span.textContent || '').trim();
      if (!/^\d{1,3}$/.test(t)) return;
      var sib = span.nextElementSibling;
      if (!sib || sib.tagName !== 'SPAN') return;
      var u = (sib.textContent || '').trim().toLowerCase();
      if (!UNITS[u]) return;
      var box = span.parentElement;
      var groupEl = box.parentElement;
      var g = groups.find(function (x) { return x.el === groupEl; });
      if (!g) { g = { el: groupEl, parts: [] }; groups.push(g); }
      g.parts.push({ span: span, unit: u });
    });

    groups.forEach(function (g) {
      var total = 0;
      g.parts.forEach(function (p) { total += parseInt(p.span.textContent, 10) * UNITS[p.unit]; });
      if (total <= 0) return;
      function render() {
        var rem = total;
        g.parts.forEach(function (p) {
          var v = Math.floor(rem / UNITS[p.unit]);
          rem -= v * UNITS[p.unit];
          p.span.textContent = (v < 10 ? '0' : '') + v;
        });
      }
      render();
      var iv = setInterval(function () {
        total--;
        if (total < 0) { total = 0; clearInterval(iv); }
        render();
      }, 1000);
    });
  }

  /* ---------- CAROUSEL (single-image swap) ---------- */
  function initCarousels() {
    document.querySelectorAll('[data-carousel-images]').forEach(function (cont) {
      var imgs;
      try { imgs = JSON.parse(cont.getAttribute('data-carousel-images')); } catch (e) { return; }
      if (!imgs || imgs.length < 2) return;
      var img = cont.querySelector('img');
      var prev = cont.querySelector('button[aria-label="Previous slide"]');
      var next = cont.querySelector('button[aria-label="Next slide"]');
      var dots = cont.querySelectorAll('button[aria-label^="Go to slide"]');
      var counter = cont.querySelector('p');
      if (!img) return;
      var idx = 0;
      function render() {
        img.src = imgs[idx];
        dots.forEach(function (d, i) {
          d.className = 'w-2.5 h-2.5 rounded-full transition-all ' +
            (i === idx ? 'bg-primary scale-125' : 'bg-primary/30');
        });
        if (counter) counter.textContent = (idx + 1) + ' / ' + imgs.length + ' — Swipe to browse categories →';
      }
      function go(n) { idx = (n + imgs.length) % imgs.length; render(); }
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(idx - 1); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(idx + 1); });
      dots.forEach(function (d, i) { d.addEventListener('click', function (e) { e.preventDefault(); go(i); }); });
      var x0 = null;
      cont.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      cont.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(dx < 0 ? idx + 1 : idx - 1);
        x0 = null;
      }, { passive: true });
      render();
    });
  }

  function init() { initAccordions(); initCountdowns(); initCarousels(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
